// extracted by mini-css-extract-plugin
export var notificationHost = "_gr-0";